import { render } from "./TotalPanel.vue?vue&type=template&id=3d921ed2&scoped=true"
import script from "./TotalPanel.vue?vue&type=script&lang=js"
export * from "./TotalPanel.vue?vue&type=script&lang=js"

import "./TotalPanel.vue?vue&type=style&index=0&id=3d921ed2&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d921ed2"]])

export default __exports__